import { CurrentUser } from "@superwall/api-schema-utils"
import { Schema } from "effect"

export const UserId = CurrentUser.UserId
export type UserId = Schema.Schema.Type<typeof UserId>

export const PaywallId = Schema.Int.pipe(Schema.brand("@superwall/schema/PaywallId"))
export type PaywallId = Schema.Schema.Type<typeof PaywallId>
export const PaywallIdFromString = Schema.NumberFromString.pipe(
  Schema.brand("@superwall/schema/PaywallId")
)
export type PaywallIdFromString = Schema.Schema.Type<typeof PaywallIdFromString>

export const PaywallVersionId = Schema.Int.pipe(Schema.brand("@superwall/schema/PaywallVersionId"))
export type PaywallVersionId = Schema.Schema.Type<typeof PaywallVersionId>

export const PaywallSnapshotId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/PaywallSnapshotId")
)
export type PaywallSnapshotId = Schema.Schema.Type<typeof PaywallSnapshotId>

export const ApplicationId = Schema.Int.pipe(Schema.brand("@superwall/schema/ApplicationId"))
export type ApplicationId = Schema.Schema.Type<typeof ApplicationId>
export const ApplicationIdFromString = Schema.NumberFromString.pipe(
  Schema.brand("@superwall/schema/ApplicationId")
)
export type ApplicationIdFromString = Schema.Schema.Type<typeof ApplicationIdFromString>

export const OrganizationId = Schema.Int.pipe(Schema.brand("@superwall/schema/OrganizationId"))
export type OrganizationId = Schema.Schema.Type<typeof OrganizationId>
export const OrganizationIdFromString = Schema.NumberFromString.pipe(
  Schema.brand("@superwall/schema/OrganizationId")
)
export type OrganizationIdFromString = Schema.Schema.Type<typeof OrganizationIdFromString>

export const ApplicationAnalyticsMetadataId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/ApplicationAnalyticsMetadataId")
)
export type ApplicationAnalyticsMetadataId = Schema.Schema.Type<
  typeof ApplicationAnalyticsMetadataId
>

export const ApplicationAsaConfigurationId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/ApplicationAsaConfigurationId")
)
export type ApplicationAsaConfigurationId = Schema.Schema.Type<typeof ApplicationAsaConfigurationId>

export const ApplicationAscConfigurationId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/ApplicationAscConfigurationId")
)
export type ApplicationAscConfigurationId = Schema.Schema.Type<typeof ApplicationAscConfigurationId>

export const ApplicationAssConfigurationId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/ApplicationAssConfigurationId")
)
export type ApplicationAssConfigurationId = Schema.Schema.Type<typeof ApplicationAssConfigurationId>

export const ApplicationAuthenticationTokenId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/ApplicationAuthenticationTokenId")
)
export type ApplicationAuthenticationTokenId = Schema.Schema.Type<
  typeof ApplicationAuthenticationTokenId
>

export const ApplicationConfigCacheId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/ApplicationConfigCacheId")
)
export type ApplicationConfigCacheId = Schema.Schema.Type<typeof ApplicationConfigCacheId>

export const ApplicationETLDestinationId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/ApplicationETLDestinationId")
)
export type ApplicationETLDestinationId = Schema.Schema.Type<typeof ApplicationETLDestinationId>

export const ApplicationGPAuthConfigurationId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/ApplicationGPAuthConfigurationId")
)
export type ApplicationGPAuthConfigurationId = Schema.Schema.Type<
  typeof ApplicationGPAuthConfigurationId
>

export const ApplicationLiveStripeConfigurationId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/ApplicationLiveStripeConfigurationId")
)
export type ApplicationLiveStripeConfigurationId = Schema.Schema.Type<
  typeof ApplicationLiveStripeConfigurationId
>

export const ApplicationMarketingMetadataId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/ApplicationMarketingMetadataId")
)
export type ApplicationMarketingMetadataId = Schema.Schema.Type<
  typeof ApplicationMarketingMetadataId
>

export const ApplicationSettingId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/ApplicationSettingId")
)
export type ApplicationSettingId = Schema.Schema.Type<typeof ApplicationSettingId>

export const ApplicationSettingsId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/ApplicationSettingsId")
)
export type ApplicationSettingsId = Schema.Schema.Type<typeof ApplicationSettingsId>

export const ApplicationTestStripeConfigurationId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/ApplicationTestStripeConfigurationId")
)
export type ApplicationTestStripeConfigurationId = Schema.Schema.Type<
  typeof ApplicationTestStripeConfigurationId
>

export const ApplicationUseageRecordId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/ApplicationUseageRecordId")
)
export type ApplicationUseageRecordId = Schema.Schema.Type<typeof ApplicationUseageRecordId>

export const ApplicationUserId = Schema.BigInt.pipe(
  Schema.brand("@superwall/schema/ApplicationUserId")
)
export type ApplicationUserId = Schema.Schema.Type<typeof ApplicationUserId>

export const ApplicationUserAliasId = Schema.BigInt.pipe(
  Schema.brand("@superwall/schema/ApplicationUserAliasId")
)
export type ApplicationUserAliasId = Schema.Schema.Type<typeof ApplicationUserAliasId>

export const ApplicationUserAttributeMappingId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/ApplicationUserAttributeMappingId")
)
export type ApplicationUserAttributeMappingId = Schema.Schema.Type<
  typeof ApplicationUserAttributeMappingId
>

export const ApplicationUserEventId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/ApplicationUserEventId")
)
export type ApplicationUserEventId = Schema.Schema.Type<typeof ApplicationUserEventId>

export const ApplicationUserNotificationV2AssigmentId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/ApplicationUserNotificationV2AssigmentId")
)
export type ApplicationUserNotificationV2AssigmentId = Schema.Schema.Type<
  typeof ApplicationUserNotificationV2AssigmentId
>

export const ApplicationWebhookDestinationId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/ApplicationWebhookDestinationId")
)
export type ApplicationWebhookDestinationId = Schema.Schema.Type<
  typeof ApplicationWebhookDestinationId
>

export const AssignmentId = Schema.Int.pipe(Schema.brand("@superwall/schema/AssignmentId"))
export type AssignmentId = Schema.Schema.Type<typeof AssignmentId>

export const BotUserId = Schema.Int.pipe(Schema.brand("@superwall/schema/BotUserId"))
export type BotUserId = Schema.Schema.Type<typeof BotUserId>

export const ChatOpsSettingsId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/ChatOpsSettingsId")
)
export type ChatOpsSettingsId = Schema.Schema.Type<typeof ChatOpsSettingsId>

export const CurrencyExchangeRateId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/CurrencyExchangeRateId")
)
export type CurrencyExchangeRateId = Schema.Schema.Type<typeof CurrencyExchangeRateId>

export const CustomerDomainId = Schema.Int.pipe(Schema.brand("@superwall/schema/CustomerDomainId"))
export type CustomerDomainId = Schema.Schema.Type<typeof CustomerDomainId>

export const EntitlementId = Schema.Int.pipe(Schema.brand("@superwall/schema/EntitlementId"))
export type EntitlementId = Schema.Schema.Type<typeof EntitlementId>

export const ExperimentId = Schema.Int.pipe(Schema.brand("@superwall/schema/ExperimentId"))
export type ExperimentId = Schema.Schema.Type<typeof ExperimentId>

export const GloballyEnabledFeatureId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/GloballyEnabledFeatureId")
)
export type GloballyEnabledFeatureId = Schema.Schema.Type<typeof GloballyEnabledFeatureId>

export const IntegrationAuthenticationTokenId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/IntegrationAuthenticationTokenId")
)
export type IntegrationAuthenticationTokenId = Schema.Schema.Type<
  typeof IntegrationAuthenticationTokenId
>

export const LocalizableStringId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/LocalizableStringId")
)
export type LocalizableStringId = Schema.Schema.Type<typeof LocalizableStringId>

export const LocalizationFileUploadId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/LocalizationFileUploadId")
)
export type LocalizationFileUploadId = Schema.Schema.Type<typeof LocalizationFileUploadId>

export const LocalizationProviderId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/LocalizationProviderId")
)
export type LocalizationProviderId = Schema.Schema.Type<typeof LocalizationProviderId>

export const LocalizationProviderFilePathId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/LocalizationProviderFilePathId")
)
export type LocalizationProviderFilePathId = Schema.Schema.Type<
  typeof LocalizationProviderFilePathId
>

export const LocalizationProviderKeyNameId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/LocalizationProviderKeyNameId")
)
export type LocalizationProviderKeyNameId = Schema.Schema.Type<typeof LocalizationProviderKeyNameId>

export const LocalizationProviderSyncId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/LocalizationProviderSyncId")
)
export type LocalizationProviderSyncId = Schema.Schema.Type<typeof LocalizationProviderSyncId>

export const LocalizedProductId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/LocalizedProductId")
)
export type LocalizedProductId = Schema.Schema.Type<typeof LocalizedProductId>

export const LocalizedStringId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/LocalizedStringId")
)
export type LocalizedStringId = Schema.Schema.Type<typeof LocalizedStringId>

export const MembershipId = Schema.Int.pipe(Schema.brand("@superwall/schema/MembershipId"))
export type MembershipId = Schema.Schema.Type<typeof MembershipId>

export const MembershipTokenId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/MembershipTokenId")
)
export type MembershipTokenId = Schema.Schema.Type<typeof MembershipTokenId>

export const NotificationNodeId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/NotificationNodeId")
)
export type NotificationNodeId = Schema.Schema.Type<typeof NotificationNodeId>

export const NotificationNodeV2Id = Schema.Int.pipe(
  Schema.brand("@superwall/schema/NotificationNodeV2Id")
)
export type NotificationNodeV2Id = Schema.Schema.Type<typeof NotificationNodeV2Id>

export const NotificationPlanId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/NotificationPlanId")
)
export type NotificationPlanId = Schema.Schema.Type<typeof NotificationPlanId>

export const NotificationTimelineId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/NotificationTimelineId")
)
export type NotificationTimelineId = Schema.Schema.Type<typeof NotificationTimelineId>

export const NotificationTimelineV2Id = Schema.Int.pipe(
  Schema.brand("@superwall/schema/NotificationTimelineV2Id")
)
export type NotificationTimelineV2Id = Schema.Schema.Type<typeof NotificationTimelineV2Id>

export const OAuth2AccessTokenId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/OAuth2AccessTokenId")
)
export type OAuth2AccessTokenId = Schema.Schema.Type<typeof OAuth2AccessTokenId>

export const OAuth2AuthorizationCodeId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/OAuth2AuthorizationCodeId")
)
export type OAuth2AuthorizationCodeId = Schema.Schema.Type<typeof OAuth2AuthorizationCodeId>

export const OrganizationLocalizationTargetId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/OrganizationLocalizationTargetId")
)
export type OrganizationLocalizationTargetId = Schema.Schema.Type<
  typeof OrganizationLocalizationTargetId
>

export const OrganizationUsageRecordId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/OrganizationUsageRecordId")
)
export type OrganizationUsageRecordId = Schema.Schema.Type<typeof OrganizationUsageRecordId>

export const PaywallAssetId = Schema.Int.pipe(Schema.brand("@superwall/schema/PaywallAssetId"))
export type PaywallAssetId = Schema.Schema.Type<typeof PaywallAssetId>

export const PaywallLanguageRequirementId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/PaywallLanguageRequirementId")
)
export type PaywallLanguageRequirementId = Schema.Schema.Type<typeof PaywallLanguageRequirementId>

export const PaywallLocalizableStringRequirementId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/PaywallLocalizableStringRequirementId")
)
export type PaywallLocalizableStringRequirementId = Schema.Schema.Type<
  typeof PaywallLocalizableStringRequirementId
>

export const PaywallLocalizationId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/PaywallLocalizationId")
)
export type PaywallLocalizationId = Schema.Schema.Type<typeof PaywallLocalizationId>

export const PaywallPreviewId = Schema.Int.pipe(Schema.brand("@superwall/schema/PaywallPreviewId"))
export type PaywallPreviewId = Schema.Schema.Type<typeof PaywallPreviewId>

export const PaywallResourceId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/PaywallResourceId")
)
export type PaywallResourceId = Schema.Schema.Type<typeof PaywallResourceId>

export const PaywallResourcePaywallVersionRequirementId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/PaywallResourcePaywallVersionRequirementId")
)
export type PaywallResourcePaywallVersionRequirementId = Schema.Schema.Type<
  typeof PaywallResourcePaywallVersionRequirementId
>

export const PaywallResourcePaywallVersionVarintFixtureId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/PaywallResourcePaywallVersionVarintFixtureId")
)
export type PaywallResourcePaywallVersionVarintFixtureId = Schema.Schema.Type<
  typeof PaywallResourcePaywallVersionVarintFixtureId
>

export const PaywallResourceRequirementId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/PaywallResourceRequirementId")
)
export type PaywallResourceRequirementId = Schema.Schema.Type<typeof PaywallResourceRequirementId>

export const PaywallResourceVersionId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/PaywallResourceVersionId")
)
export type PaywallResourceVersionId = Schema.Schema.Type<typeof PaywallResourceVersionId>

export const PaywallResourceVersionVariantId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/PaywallResourceVersionVariantId")
)
export type PaywallResourceVersionVariantId = Schema.Schema.Type<
  typeof PaywallResourceVersionVariantId
>

export const PaywallSurveyId = Schema.Int.pipe(Schema.brand("@superwall/schema/PaywallSurveyId"))
export type PaywallSurveyId = Schema.Schema.Type<typeof PaywallSurveyId>

export const PaywallTemplateId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/PaywallTemplateId")
)
export type PaywallTemplateId = Schema.Schema.Type<typeof PaywallTemplateId>

export const PaywallTriggerId = Schema.Int.pipe(Schema.brand("@superwall/schema/PaywallTriggerId"))
export type PaywallTriggerId = Schema.Schema.Type<typeof PaywallTriggerId>

export const ProductId = Schema.Int.pipe(Schema.brand("@superwall/schema/ProductId"))
export type ProductId = Schema.Schema.Type<typeof ProductId>

export const ProductEntitlementsId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/ProductEntitlementsId")
)
export type ProductEntitlementsId = Schema.Schema.Type<typeof ProductEntitlementsId>

export const ProjectId = Schema.Int.pipe(Schema.brand("@superwall/schema/ProjectId"))
export type ProjectId = Schema.Schema.Type<typeof ProjectId>

export const ProjectApplicationId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/ProjectApplicationId")
)
export type ProjectApplicationId = Schema.Schema.Type<typeof ProjectApplicationId>

export const SDKConfigurationToggleId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/SDKConfigurationToggleId")
)
export type SDKConfigurationToggleId = Schema.Schema.Type<typeof SDKConfigurationToggleId>

export const SessionId = Schema.Int.pipe(Schema.brand("@superwall/schema/SessionId"))
export type SessionId = Schema.Schema.Type<typeof SessionId>

export const ShortLinkId = Schema.Int.pipe(Schema.brand("@superwall/schema/ShortLinkId"))
export type ShortLinkId = Schema.Schema.Type<typeof ShortLinkId>

export const StandardEventId = Schema.Int.pipe(Schema.brand("@superwall/schema/StandardEventId"))
export type StandardEventId = Schema.Schema.Type<typeof StandardEventId>

export const StorageBlobId = Schema.Int.pipe(Schema.brand("@superwall/schema/StorageBlobId"))
export type StorageBlobId = Schema.Schema.Type<typeof StorageBlobId>

export const StorefrontCurrencyPriceInfoId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/StorefrontCurrencyPriceInfoId")
)
export type StorefrontCurrencyPriceInfoId = Schema.Schema.Type<typeof StorefrontCurrencyPriceInfoId>

export const StripeProductRankingId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/StripeProductRankingId")
)
export type StripeProductRankingId = Schema.Schema.Type<typeof StripeProductRankingId>

export const SubscriptionEventId = Schema.String.pipe(
  Schema.brand("@superwall/schema/SubscriptionEventId")
)
export type SubscriptionEventId = Schema.Schema.Type<typeof SubscriptionEventId>

export const SuperwallLocalizationProviderId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/SuperwallLocalizationProviderId")
)
export type SuperwallLocalizationProviderId = Schema.Schema.Type<
  typeof SuperwallLocalizationProviderId
>

export const SurveyId = Schema.Int.pipe(Schema.brand("@superwall/schema/SurveyId"))
export type SurveyId = Schema.Schema.Type<typeof SurveyId>

export const SWLocalization_KeyId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/SWLocalization_KeyId")
)
export type SWLocalization_KeyId = Schema.Schema.Type<typeof SWLocalization_KeyId>

export const SWLocalization_KeyTranslationId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/SWLocalization_KeyTranslationId")
)
export type SWLocalization_KeyTranslationId = Schema.Schema.Type<
  typeof SWLocalization_KeyTranslationId
>

export const SWLocalization_ProjectId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/SWLocalization_ProjectId")
)
export type SWLocalization_ProjectId = Schema.Schema.Type<typeof SWLocalization_ProjectId>

export const SWLocalization_ProjectLanguageId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/SWLocalization_ProjectLanguageId")
)
export type SWLocalization_ProjectLanguageId = Schema.Schema.Type<
  typeof SWLocalization_ProjectLanguageId
>

export const TextPaywallResourceId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/TextPaywallResourceId")
)
export type TextPaywallResourceId = Schema.Schema.Type<typeof TextPaywallResourceId>

export const TextPaywallResourceVersionId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/TextPaywallResourceVersionId")
)
export type TextPaywallResourceVersionId = Schema.Schema.Type<typeof TextPaywallResourceVersionId>

export const TextPaywallResourceVersionRequirementId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/TextPaywallResourceVersionRequirementId")
)
export type TextPaywallResourceVersionRequirementId = Schema.Schema.Type<
  typeof TextPaywallResourceVersionRequirementId
>

export const TextPaywallResourceVersionVariantId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/TextPaywallResourceVersionVariantId")
)
export type TextPaywallResourceVersionVariantId = Schema.Schema.Type<
  typeof TextPaywallResourceVersionVariantId
>

export const TextPaywallResourceVersionVariantRequirementId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/TextPaywallResourceVersionVariantRequirementId")
)
export type TextPaywallResourceVersionVariantRequirementId = Schema.Schema.Type<
  typeof TextPaywallResourceVersionVariantRequirementId
>

export const TextPaywallResourceVersionVariantVersionId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/TextPaywallResourceVersionVariantVersionId")
)
export type TextPaywallResourceVersionVariantVersionId = Schema.Schema.Type<
  typeof TextPaywallResourceVersionVariantVersionId
>

export const TokenId = Schema.Int.pipe(Schema.brand("@superwall/schema/TokenId"))
export type TokenId = Schema.Schema.Type<typeof TokenId>

export const TriggerExperimentId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/TriggerExperimentId")
)
export type TriggerExperimentId = Schema.Schema.Type<typeof TriggerExperimentId>

export const TriggerExperimentGroupId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/TriggerExperimentGroupId")
)
export type TriggerExperimentGroupId = Schema.Schema.Type<typeof TriggerExperimentGroupId>
export const TriggerExperimentGroupIdFromString = Schema.NumberFromString.pipe(
  Schema.brand("@superwall/schema/TriggerExperimentGroupId")
)
export type TriggerExperimentGroupIdFromString = Schema.Schema.Type<
  typeof TriggerExperimentGroupIdFromString
>

export const UserMarketingMetadataId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/UserMarketingMetadataId")
)
export type UserMarketingMetadataId = Schema.Schema.Type<typeof UserMarketingMetadataId>

export const VariantId = Schema.Int.pipe(Schema.brand("@superwall/schema/VariantId"))
export type VariantId = Schema.Schema.Type<typeof VariantId>

export const WebPaywallId = Schema.Int.pipe(Schema.brand("@superwall/schema/WebPaywallId"))
export type WebPaywallId = Schema.Schema.Type<typeof WebPaywallId>

export const WebPaywallDomainId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/WebPaywallDomainId")
)
export type WebPaywallDomainId = Schema.Schema.Type<typeof WebPaywallDomainId>

export const WebPaywallTriggerId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/WebPaywallTriggerId")
)
export type WebPaywallTriggerId = Schema.Schema.Type<typeof WebPaywallTriggerId>

export const WebProductId = Schema.Int.pipe(Schema.brand("@superwall/schema/WebProductId"))
export type WebProductId = Schema.Schema.Type<typeof WebProductId>

export const Web2AppIntegrationId = Schema.Int.pipe(
  Schema.brand("@superwall/schema/Web2AppIntegrationId")
)
export type Web2AppIntegrationId = Schema.Schema.Type<typeof Web2AppIntegrationId>

export const Web2AppIntegrationTypeId = Schema.Union(
  Schema.Literal("facebook-pixel"),
  Schema.Literal("console-logger"),
  Schema.Literal("google-tag-manager")
)
export type Web2AppIntegrationTypeId = Schema.Schema.Type<typeof Web2AppIntegrationTypeId>
